import script from "./LessonDiscussion.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonDiscussion.vue?vue&type=script&setup=true&lang=ts"

import "./LessonDiscussion.vue?vue&type=style&index=0&id=3c0fa3ca&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0fa3ca"]])

export default __exports__